module.exports = __webpack_public_path__ + "static/media/pen-alt.679e5ac4.svg";